export default class SyncSupplierItemsRequest {
  constructor(
    public supplierId: number,
    public supplierItems: SyncSupplierItemRequest[]) {
  }
}

export class SyncSupplierItemRequest {
  constructor(
    public itemId: number,
    public code: string,
    public orderUnitCode: string,
    public name: string | undefined,
    public description: string | undefined,
    public proposedOrderQuantity: number | undefined
  ) {}
}
